"use client";

import { Button } from "@/components/ui/button";
import {
	Dialog,
	DialogBody,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { useStoragePersistence } from "@/services/storage/use-storage-persistence";

export function StoragePersistenceDialog() {
	const { showDialog, onConfirm, onDismiss } = useStoragePersistence();

	return (
		<Dialog open={showDialog} onOpenChange={(open) => !open && onDismiss()}>
			<DialogContent className="sm:max-w-md">
				<DialogHeader>
					<DialogTitle>Не теряйте свои проекты</DialogTitle>
				</DialogHeader>
				<DialogBody>
					<p className="text-base text-muted-foreground">
						Ваш браузер может автоматически удалить проекты, если места в
						хранилище станет мало.
					</p>
					<p className="text-base text-muted-foreground">
						Разрешить OpenCut защитить их?
					</p>
				</DialogBody>
				<DialogFooter>
					<Button variant="outline" onClick={onDismiss}>
						Не сейчас
					</Button>
					<Button onClick={onConfirm}>Разрешить</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}
